import { CollapsibleContent } from '@fiverr-private/disclosure';
import withImpression from '../helpers/withImpression';

export default withImpression(CollapsibleContent);
